import React, { forwardRef, useLayoutEffect, useRef } from "react";
import Modal from "./Modal";
import Button from "../forms/Button";
const ConfirmationModal = ({
  title,
  message,
  isOpen,
  setIsOpen,
  isCentered,
  size,
  icon,
  cancleColor = "primary",
  btnColor = "danger",
  btnTitle,
  handleOnConfirm,
  isBtnShow = true,
  isCrossBtnShow = true,
  BtnChildren,
  ...props
}) => {
  return (
    <Modal
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      id="confirmationModal"
      title={title}
      size={"sm"}
      isCentered={true}
      BtnChildren={() => (
        <>
          <Button
            color={cancleColor}
            icon={icon}
            isLight
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>
          <Button
            color={btnColor}
            icon={icon}
            onClick={handleOnConfirm}
            isLight
          >
            {btnTitle}
          </Button>
        </>
      )}
    >
      <div>{message}</div>
    </Modal>
  );
};
export default ConfirmationModal;
